import React,{useContext} from 'react';
import {global} from '../App';
import logo from "../imgs/logo.png";

export default function Header() {
  const {newFile,setNewFile}=useContext(global);
 
  function newfilefun(){
   if (!newFile) {
    setNewFile(true);
   }

  }
  return <header>
    <img src={logo} alt="logo" />
    <button onClick={newfilefun}>New File</button>
</header>
}
